import { isUnavailableDateForFuture } from "../helper";

export const validateJourneyId = (value: string): string | undefined => {
  if (!value.trim()) {
    return "Oops, you must enter a reference number.";
  }
  if (!/^\d+$/.test(value)) {
    return "Oops, reference number should be digits.";
  }
  return undefined;
};

export const validatePostcode = (value: string): string | undefined => {
  if (!value.trim()) {
    return "Oops, you must enter a postcode.";
  }
  if (!/^\d{4}$/.test(value)) {
    return "Oops, postcodes should be 4 digits.";
  }
  return undefined;
};

export const validateMeterNumber = (value: string): string | undefined => {
  if (!value.trim()) {
    return "Oops, you must enter a meter number. This can be found on your latest bill.";
  }
  if (!/^[a-zA-Z0-9,\s]*$/.test(value)) {
    return "Meter number can only contain letters, numbers, and commas.";
  }
  return undefined;
};

export const validateScheduleDate = (date: Date | null): string | undefined => {
  if (!date || isNaN(date.getTime()) || isUnavailableDateForFuture(date)) {
    return "Oops, you must enter a date of abolishment. Removal may occur on this date or take up to 30 business days.";
  }
  return undefined;
};
